<template>
  <!-- <card :header-text="'Raw Data '+ company.companyname"> -->
  <div  v-if="comp">
    <div class="row mb5 mt15">
      <div class="col-md-10"></div>
      <div class="col-md-2" v-if="rawdata.length>0">
        <download :tableId="rdType" :fileName="comp.companyname+'-'+rdType"></download>
      </div>
    </div>
    <div class="table-responsive app" v-dragscroll="true">
      <table :id="rdType" class="table table-bordered fonts11 app-inner">
        <thead v-if="rawdata.length>0">
          <tr>
            <th>Sr.</th>
            <th v-for="(tc, index) in columns" v-bind:key="index+'tc'+tc.title">{{tc.name}}</th>
          </tr>
        </thead>
        <tbody v-if="rawdata.length>0">
          <tr v-for="(tr, ind) in rawdata" v-bind:key="'trBod'+'-'+ind">
            <td>{{ind+1}}</td>
            <td v-for="(cl, index) in columns" v-bind:key="index+'cldata'+cl.title">
              <!-- {{cl.orgKey}}{{[cl.title]}}{{[ind]}} {{tr[cl.title]}} -->
              <span
                v-if="cl.title==='OPENDATE' || cl.title==='CLOSDATE'"
              >{{(tr[cl.title])? getDateTime(tr[cl.title]): '-'}}</span>
              <span v-else-if="cl.title==='Date'">{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
              <span v-else-if="cl.type && cl.type==='boolean'">{{(tr[cl.title])? 'Yes': 'No'}}</span>
              <span v-else-if="cl.type && cl.type==='date'">{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
              <span v-else-if="cl.type && cl.type==='year'">{{(tr[cl.title])? getYearFromQrtr(tr[cl.title]): '-'}}</span>
              <span v-else>{{(tr[cl.title])? tr[cl.title]: '-'}}</span>
            </td>
          </tr>
        </tbody>
        <tr v-if="rawdata.length===0">
          <td>
            <div class="alert alert-danger" role="alert">No data found!</div>
          </td>
        </tr>
      </table>
    </div>
    <!-- <div v-else class="table-responsive">
      <div class="row mt10">
        <div class="col-md-12">
          <div class="alert alert-danger" role="alert">No data found!</div>
        </div>
      </div>
    </div>-->
  </div>
  <!-- </card> -->
</template>
<script>
import { commonMixins } from "../../../assets/mixins/common.js";
import { rawMixins } from "../../../assets/mixins/rawMixins.js";
export default {
  props: ["issuesData", "comp", "rdType", "columns", "rows"],
  mixins: [commonMixins, rawMixins],
  created() {},
  methods: {},
  data() {
    return {
      rawdata: []
    };
  },
  watch: {
    issuesData: function(value) {
      // console.log(this.issuesData, value);
      this.rawdata = value;
    }
  },
  computed: {}
};
</script>



// WEBPACK FOOTER //
// src/views/company/rawdata/issues.vue